/**
 * GENERATED from prototype/index.html.
 * Regenerate with: node tools/gen-data.mjs
 *
 * These are the same numbers prototype/verify.js asserts and the Django
 * seeder loads (backend/apps/game/management/commands/seed_gamedata.py).
 * Do not hand-edit — change the prototype, regenerate, re-run both suites.
 */
import type { AdPlacement, Hazard } from './types';

/** Hazards tax STAMINA only — never currency, items or depth. */
export const HAZARDS: readonly Hazard[] = [
  { key:"falling", name:"Falling Rocks", message:"Debris rains down from the ceiling.", stamina:6 },
  { key:"gas", name:"Poison Gas", message:"A sour pocket of gas. You push through.", stamina:4 },
  { key:"bats", name:"Bats", message:"A colony scatters past your torch.", stamina:2 },
  { key:"river", name:"Underground River", message:"You wade through cold water.", stamina:8 },
  { key:"lava", name:"Lava Vent", message:"Heat blasts the corridor.", stamina:10 },
  { key:"ice", name:"Ice Floor", message:"You slip and lose your footing.", stamina:5 },
  { key:"dark", name:"Sudden Darkness", message:"Your flame gutters.", stamina:4 },
  { key:"quake", name:"Earthquake", message:"The walls shift — something harder blocks you.", stamina:0, harder:true },
] as const;

export const AD_PLACEMENTS: readonly AdPlacement[] = [
  { key:"hub_kyat", name:"Watch Ad", description:"+0.20 Shwe Kyat", icon:"💎", dailyCap:20, cooldownSeconds:60, kyat:0.2 },
  { key:"hub_double", name:"Double Rewards", description:"2x coins for 10 minutes", icon:"🪙", dailyCap:3, cooldownSeconds:600 },
  { key:"hub_mystery", name:"Mystery Box", description:"Coins, Kyat or an Ancient Key", icon:"🎁", dailyCap:5, cooldownSeconds:300 },
  { key:"hub_stamina", name:"Refill Stamina", description:"Back to full, instantly", icon:"😮‍💨", dailyCap:8, cooldownSeconds:0 },
  { key:"hub_reveal", name:"Reveal Treasure", description:"Glow treasure rocks for 25s", icon:"✨", dailyCap:6, cooldownSeconds:600 },
  { key:"hub_auto", name:"Auto-dig", description:"Swings and walks for 45s", icon:"🤖", dailyCap:6, cooldownSeconds:120 },
] as const;

export const EVENT_CHANCES = {
  hazard: 0.12,
  spirit: 0.12,
  spiritWindowMs: 30_000,
  hiddenChest: 0.10,
  hiddenChestLuna: 0.18,
  mysteryDoor: 0.03,
  doubleLoot: 0.12,
  rockyExtra: 0.08,
  ancientKey: 0.20,
} as const;

export const WITHDRAW = { min: 50, max: 500, perWeek: 2 } as const;

export const CONFIG = {
  pxPerMetre: 42,
  stepMetres: 2,
  stepMs: 420,
  minerX: 0.24,
  floor: 0.80,
  reachBack: 1.0,
  reachForward: 4.6,
  staminaMax: 120,
  staminaWalk: 2,
  staminaSwing: 1,
  staminaRegenMs: 2100,
  baseHp: 30,
  hpPerMetre: 0.0012,
  coinPerMetre: 0.010,
  /** Material hardness saturates here; DEPTH itself is endless. */
  materialCurveMetres: 1400,
  segmentMetres: 3,
  cacheEveryMetres: 50,
} as const;
